<script>
/* eslint-disable no-console */
/**
 * Item List component
 */
export default {
  components: { },
  data() {
    return {
      data: null,
      valueList: false,
      valueView: false,
      valueAdd: false,
      valueEdit: false,
      valueDelete: false,
      valueExport: false,

      showList: true,
      showView: true,
      showAdd: true,
      showEdit: true,
      showDelete: true,
      showExport: true,
    };
  },
  watch: {

    item: {
      immediate: true, 
      handler (val) {

        this.data = val;
        this.valueList = val.list == 1;
        this.valueView = val.view == 1;
        this.valueAdd = val.insert == 1;
        this.valueEdit = val.edit == 1;
        this.valueDelete = val.delete == 1;
        this.valueExport = val.export == 1;

        this.showList = !(val.list == -1);
        this.showView = !(val.view == -1);
        this.showAdd = !(val.insert == -1);
        this.showEdit = !(val.edit == -1);
        this.showDelete = !(val.delete == -1);
        this.showExport = !(val.export == -1);
      }
    },
  },
  mounted() { },
  methods: {
    getValue: function() {
      if(+this.data.id == -1) {
        return null;
      } else {
        return {
            id: +this.data.id,
            privilege_id: this.data.privilege_id,
            manage_type: this.data.manage_type,
            group: this.data.group,
            group_en: this.data.group_en,
            name: this.data.name,
            name_en: this.data.name_en,
            list: !this.showList ? -1 : this.valueList ? 1 : 0,
            view: !this.showView ? -1 : this.valueView ? 1 : 0,
            insert: !this.showAdd ? -1 : this.valueAdd ? 1 : 0,
            edit: !this.showEdit ? -1 : this.valueEdit ? 1 : 0,
            delete: !this.showDelete ? -1 : this.valueDelete ? 1 : 0,
            export: !this.showExport ? -1 : this.valueExport ? 1 : 0,
        };
      }
    },

    checked: function(e) {

      console.log(e);
      if(+this.data.id == -1) {
        this.data.id = 0;
      }

    },

    listChecked: function(e) {
      this.checked(e);
    },
    viewChecked: function(e) {
      this.checked(e);
    },
    addChecked: function(e) {
      this.checked(e);
    },
    editChecked: function(e) {
      this.checked(e);
    },
    deleteChecked: function(e) {
      this.checked(e);
    },
    exportChecked: function(e) {
      this.checked(e);
    }

  },
  props: {
    item: null,
    index: {
      type: Number,
      default: 0
    },  
  },
};
</script>
<template>
  <div class="row" style="border-bottom: 1px solid #e6e6e6; margin-left: 10px; padding-top: 10px; padding-bottom: 10px;">
    <div class="col-md-6">{{`${item.name} (${item.name_en})`}}</div>
    <div v-show="showList" class="col-md-1"><input class="form-check-input" type="checkbox" :id="`list_${index}`" v-model="valueList" @change="listChecked($event)" /></div>
    <div v-show="showAdd" class="col-md-1"><input class="form-check-input" type="checkbox" :id="`view_${index}`" v-model="valueView" @change="viewChecked($event)" /></div>
    <div v-show="showEdit" class="col-md-1"><input class="form-check-input" type="checkbox" :id="`add_${index}`" v-model="valueAdd" @change="addChecked($event)" /></div>
    <div v-show="showEdit" class="col-md-1"><input class="form-check-input" type="checkbox" :id="`edit_${index}`" v-model="valueEdit" @change="editChecked($event)" /></div>
    <div v-show="showDelete" class="col-md-1"><input class="form-check-input" type="checkbox" :id="`delete_${index}`" v-model="valueDelete" @change="deleteChecked($event)" /></div>
    <div v-show="showExport" class="col-md-1"><input class="form-check-input" type="checkbox" :id="`export_${index}`" v-model="valueExport" @change="exportChecked($event)" /></div>
  </div>
</template>